
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-1 0 22 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.492 7.402h.899c2.022 0 3.595 1.573 3.595 3.595 0 2.023-1.573 3.595-3.595 3.595h-.899","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1 7.402h14.493v8.202c0 2.022-1.573 3.595-3.595 3.595h-7.19c-2.023 0-3.596-1.573-3.596-3.595V7.402H1zM4.707 1v2.696M8.303 1v2.696M11.898 1v2.696","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    